import DashboardIcon from '@/components/Svg/school/menu/dashboard'
import LaboratoriesIcon from '@/components/Svg/school/menu/laboratories'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

const getBackOfficeSchoolInterneAdminConsult = [
  {
    route: 'Dashboard',
    text: 'Tableau de bord',
    icon: DashboardIcon,
    href: '/backoffice/group/dashboard-admin',
    home: true,
    menuHeader: true,
    position: 10,
  },
  {
    route: 'ConsultFormatheque',
    text: 'Formathèque',
    icon: LaboratoriesIcon,
    href: '/backoffice/school/consult-formatheque',
    menuHeader: true,
    position: 40,
  },
  {
    route: 'MyProfile',
    text: 'Mon profil',
    href: '/backoffice/common/my-profile',
    menuHeader: false,
  },
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISCHOOL],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_SCHOOL_INTERNE_ADMIN_CONSULT],
}))

export default getBackOfficeSchoolInterneAdminConsult
